import { Flex, Box, useMatchBreakpoints, Button } from '@noahswap/uikit'
import React, { useState } from 'react'
import styled from 'styled-components'
import { useTranslation } from '@noahswap/localization'

type ProgressProps = {
  type?: number
  tabList?: any
  setType?: any
}
const TabsWrap = styled(Flex)``
const TabsButton = styled(Button)`
  /* width: 120px; */
  background-color: transparent;
  height: 40px;
  font-size: 14px;
  &:nth-child(1) {
    border-radius: 6px 0 0 6px;
  }
  &:nth-child(2) {
    border-radius: 0 6px 6px 0;
    border-left: 0;
    margin-left: -2px;
  }
`
const Tabs: React.FC<React.PropsWithChildren<ProgressProps>> = ({ tabList = [], type = 0, setType }: any) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()

  const handleCheck = (item: any) => {
    setType(item.value)
  }

  return (
    <TabsWrap>
      {
        // #FFE169
        tabList.map((v, i) => {
          return (
            <TabsButton
              style={{
                background: type === i ? '#FFE169' : 'transparent',
              }}
              key={i as any}
              isMobile={isMobile}
              onClick={() => {
                handleCheck(v)
              }}
            >
              {' '}
              {v.label}
            </TabsButton>
          )
        })
      }
    </TabsWrap>
  )
}

export default Tabs
